export default (definedNamespace, namespace) ->
  namespace.every (n) -> definedNamespace.includes n